import { observer } from 'mobx-react-lite'
import { CommonOptInOnlineFormContent } from 'pages/settings/pages/compliance/ui/CommonOptInContent/ui/CommonOptInOnlineFormContent'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { TollFreeRoutesSteps } from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { usePathSegment } from 'pages/settings/pages/compliance/hooks/usePathSegment'
import { RegistrationErrorAlert } from 'pages/settings/pages/compliance/pages/tollFree/ui/RegistrationErrorAlert/RegistrationErrorAlert'

export const OptInOnlineFormConsent = observer(() => {
  const { optInConsentStore, stepLoading } = useTollFreeStepsContext()
  const {
    getOptInImagesAsAttach,
    deleteAttachment,
    clearAttachmentError,
    getOptInAttachmentError,
    nextStepClick,
    uploadOptInImageAttachment,
    isOnlineFormNextDisabled,
    commonOptInConsentStore,
  } = optInConsentStore
  const lastPathSegment = usePathSegment<TollFreeRoutesSteps>()

  return (
    <>
      <RegistrationErrorAlert />
      <CommonOptInOnlineFormContent
        stepLoading={stepLoading}
        getOptInImagesAsAttach={() =>
          getOptInImagesAsAttach(TollFreeRoutesSteps.optInOnlineFormContent)
        }
        deleteAttachment={(url: string) =>
          deleteAttachment(url, TollFreeRoutesSteps.optInOnlineFormContent)
        }
        uploadAttachment={(attachments: File[]) =>
          uploadOptInImageAttachment(attachments, lastPathSegment)
        }
        increaseStep={() => nextStepClick(lastPathSegment)}
        clearAttachmentError={() => clearAttachmentError(lastPathSegment)}
        isOnlineFormNextDisabled={isOnlineFormNextDisabled}
        getAttachmentError={() => getOptInAttachmentError(lastPathSegment)}
        optInConsentStore={commonOptInConsentStore}
      />
    </>
  )
})
